import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { QueryKey, SectionList } from '@hub-la/fe-post'
import { isNil } from 'lodash'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ReorderPostsInput } from '../../domain/dtos/reorder-posts-input'
import { ReorderPosts } from '../../usecases/reorder-posts'
import { SaveSection } from '../../usecases/save-section'

const initialData = {
  items: [],
  page: 0,
  pageSize: 0,
  total: 0,
}

export const useReorderPosts = () => {
  const container = useContainer()
  const queryClient = useQueryClient()

  return useMutation(
    [QueryKey.reorderPosts],
    (input: ReorderPostsInput) => new SaveSection(container.get(HttpClient)).execute(input, input.id),
    {
      onMutate: (input: ReorderPostsInput) => {
        queryClient.setQueryData<SectionList>([QueryKey.listSections], (sections): SectionList => {
          if (isNil(sections)) {
            return initialData
          }

          const section = sections.items.find((section) => section.id === input.id)

          if (isNil(section)) {
            return initialData
          }

          const items = new ReorderPosts().execute({
            destination: input.destination,
            id: input.id,
            posts: section.posts,
            sections: sections.items,
            source: input.source,
          })

          return { items, page: sections.page, pageSize: sections.pageSize, total: sections.total }
        })
      },
    },
  )
}
